let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7rxgn")).then(() => parcelRequire('9QPix'));